import React from 'react';
import { DropTarget, DragSource } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import {FormattedMessage, defineMessages, injectIntl, IntlShape} from 'react-intl';
import {Button, ButtonGroup, FormGroup, ControlLabel, HelpBlock, ButtonToolbar} from 'react-bootstrap';
import {JSONTableDrop} from './JSONTableDropTable.react';
import TableDetail from '../../../fw/TableDetail.react';
import {renderPreviewDefault} from './JSONTable';

const messages = defineMessages({
	removeButtonTitle: {id: 'jsonTable.button.removeTitle', 'defaultMessage': 'Remove column from table'},
	renameButtonTitle: {id: 'jsonTable.button.renameTitle', 'defaultMessage': 'Rename column'},
	sortButtonTitle: {id: 'jsonTable.button.sortTitle', 'defaultMessage': 'Sort by this column'},
});

class JSONRowDrop extends JSONTableDrop {
	render() {

		let detail = (<TableDetail
			columns={this.getColumn()}
			data={this.props.viewWithData.view.entityViewDef}
			fixedTitleWidth
			isPreview
			metadata={this.getMetaData()}
			name={this.originName}
			render={renderPreviewDefault}
		/>);

		return this.props.connectDragSource(
			this.props.connectDropTarget(
				<small className={"JSONRowDropColumn jsonTable jsonTableNew" + (this.state.dragging ? ' dragging' : '') + (this.state.renaming ? ' renaming' : '')}>
					<div className="visibleRow">
						{detail}
						<ButtonGroup className={(this.state.renaming ? ' hidden' : '')}>
							<Button bsStyle="info" onClick={this.renameColumn.bind(this)} title={this.props.intl.formatMessage(messages.renameButtonTitle)}>
								<span className="fa fa-pencil"></span>
								<span className="title"><FormattedMessage defaultMessage="Rename" id="jsonTable.button.rename" /></span>
							</Button>
							<Button bsStyle="success" onClick={this.setSorting.bind(this)} title={this.props.intl.formatMessage(messages.sortButtonTitle)}>
								<span className={"fa " + (this.asc === false ? "fa-sort-alpha-desc" : "fa-sort-alpha-asc")}></span>
								<span className="title"><FormattedMessage defaultMessage="Sort" id="jsonTable.button.sort" /></span>
							</Button>
							<Button bsStyle="danger" onClick={this.removeColumn.bind(this)} title={this.props.intl.formatMessage(messages.removeButtonTitle)}>
								<span className="fa fa-times"></span>
								<span className="title"><FormattedMessage defaultMessage="Remove" id="jsonTable.button.remove" /></span>
							</Button>
						</ButtonGroup>
					</div>
					<div className={"rename " + (this.state.renaming ? "visible" : "hidden")}>
						<form>
							<FormGroup controlId="formBasicText" validationState={this.getValidationState()}>
								<ControlLabel><FormattedMessage defaultMessage="Custom name for row:" id="jsonTable.renameRow.title" /></ControlLabel>
								{ this.getRenameInputs() }
								<HelpBlock><FormattedMessage defaultMessage="This name will not persist when the row is removed from the view." id="jsonTable.renameRow.persistentWarning" /></HelpBlock>
							</FormGroup>
							<ButtonToolbar>
								<Button bsSize="small" bsStyle="primary" onClick={this.renameDone.bind(this)}><FormattedMessage defaultMessage="Rename" id="jsonTable.button.rename" /></Button>
								<Button bsSize="small" onClick={this.cancelRename.bind(this)}><FormattedMessage defaultMessage="Cancel" id="common.cancel" /></Button>
							</ButtonToolbar>
						</form>
					</div>
				</small>
			)
		);
	}
}

const dropHandler = {
	hover(props, monitor, component) {
		// hovering over itself
		if (props.dragging) {
			return;
		}

		const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
		const clientOffset = monitor.getClientOffset();

		const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
		const hoverClientX = clientOffset.x - hoverBoundingRect.left;
		const dragItem = monitor.getItem();

		let targetIndex = props.index;

		if (hoverMiddleX < hoverClientX) {
			targetIndex++;
		}

		if (component.props.index < targetIndex) {
			targetIndex--;
		}

		props.draggingFn(dragItem, targetIndex, monitor.getItem().originalIndex);
	},
	drop(props, monitor, component) {
		props.dropFn(monitor.getItem(), component.props.index);
	}
};

function dropActions(connect, monitor) {
	return {
		canDrop: monitor.canDrop(),
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver(),
	};
}

const dragHandler = {
	beginDrag(props) {
		return {
			column: props.column,
			originalIndex: props.index,
		};
	},

	endDrag(props, monitor) {
		if (!monitor.didDrop()) {
			props.dragEndFn();
		}
	},
};

function dragActions(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	};
}

export default DragSource('JSONTableDragColumn', dragHandler, dragActions)(
	DropTarget('JSONTableDragColumn', dropHandler, dropActions)(injectIntl(JSONRowDrop))
);
